import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { KEY_CODE_ENTER } from "../../utils";
import { createComment } from "../../actions/CommentAction";
import "./emoji-mart.css";
import "./dart_internal.css";

import Socket from "../../utils/sockets";
import { uuidv4 } from "../../utils/index";
import { startDownload, updateDownload } from "../../actions/DownloadAction";
import { setkeyboardEnabled } from "../../actions/AppAction";
import CommentV2 from "./CommentV2";

export class MainCommentsList extends Component {
  constructor(props) {
    super(props);
    this.commentRefToShow = React.createRef();
    this.scrollDiv = React.createRef();
    this.state = {
      defaultAvatar: "/images/icons/user-icon.svg",
      comment: "",
      itemsComments: [],
      mentions: []
    };
  }

  componentDidMount() {
    const { itemSelected, avatar } = this.props;

    if (avatar) {
      this.setState({
        defaultAvatar: avatar
      });
    }

    if (itemSelected && itemSelected.comments) {
      // esto ordena los comentarios de forma accendente...
      // osea mostrara primero los comentarios recientes...
      this.setState({
        itemsComments: itemSelected.comments.sort(function(a, b) {
          return new Date(b.createdAt) - new Date(a.createdAt);
        })
      });
    }
    this.props.setkeyboardEnabled(true);
  }

  componentDidUpdate(prevProps) {
    const { itemSelected, fromKeyCollection } = this.props;
    const { isAlreadyScrollToComment } = this.state;

    if (
      itemSelected.comments &&
      prevProps.itemSelected.comments !== itemSelected.comments
    ) {
      // solo entra cuando hay un nuevo comentario...
      this.setState(
        {
          itemsComments: itemSelected.comments.sort(function(a, b) {
            return new Date(b.createdAt) - new Date(a.createdAt);
          })
        },
        () =>
          this.scrollDiv.current.scroll({
            top: 0,
            behavior: "smooth"
          })
      );
    }

    if (
      !fromKeyCollection &&
      itemSelected &&
      !isAlreadyScrollToComment &&
      this.scrollDiv.current &&
      this.commentRefToShow.current
    ) {
      this.setState({ isAlreadyScrollToComment: true }, this.scrollToComment);
    }
  }

  handleKeyDownEditComment = e => {
    if (!e.shiftKey) {
      if (e.keyCode === KEY_CODE_ENTER) {
        this.handleSubmitCommentEdit();
      }
    }
  };

  downloadFileComment = (quality, comment) => {
    const commentId = comment._id.toString();
    const { attachedFile } = comment;
    const { workclient, itemSelected, intl } = this.props;
    const uuid = uuidv4();
    this.props.startDownload({
      id: itemSelected.document._id,
      uuid: uuid,
      // name: itemSelected.document.name,
      name: attachedFile.name
        ? attachedFile.name
        : itemSelected && itemSelected.document && itemSelected.document.name
        ? itemSelected.document.name
        : null,
      state: "download_in_progress",
      client: !workclient ? itemSelected.client : workclient,
      quality
    });
    Socket.getInstance().emit("request_client_download_comment", {
      // Socket.getInstance().emit("request_client_download", {
      wc: !workclient
        ? itemSelected.client._id === undefined
          ? itemSelected.client
          : itemSelected.client._id
        : workclient,
      quality,
      commentId,
      // asset: attachedFile._id,
      // // asset: comment.documentId,
      uuid,
      lang: intl.locale,
      channel: "single"
    });
  };

  scrollToReplyComment = commentId => {
    if (commentId && document.getElementById(commentId)) {
      document.getElementById(commentId).scrollIntoView({
        behavior: "smooth"
      });
    }
  };

  scrollToComment = () => {
    setTimeout(() => {
      const dataScrollView = this.scrollDiv.current.getBoundingClientRect();
      const dataCommentToShow = this.commentRefToShow.current.getBoundingClientRect();
      this.scrollDiv.current.scroll({
        top: dataCommentToShow.top - dataScrollView.top,
        behavior: "smooth"
      });
    }, 100);
  };

  scrollToAnswered = () => {
    setTimeout(() => {
      const dataScrollView = this.scrollDiv.current.getBoundingClientRect();
      const dataCommentToShow = this.commentRefToShow.current.getBoundingClientRect();
      this.scrollDiv.current.scroll({
        top: dataCommentToShow.top - dataScrollView.top,
        behavior: "smooth"
      });
    }, 100);
  };

  scrollToRef = ref => window.scrollTo(0, ref.current.offsetTop);

  render() {
    const { itemsComments } = this.state;
    const {
      itemSelectedFetching,
      itemSelected,
      adminUsersToComment,
      operatorsUsersToComment,
      isFetchingUsersToComment,
      canCreateCommentDart,
      searchComments,
      user,
      usersAll
    } = this.props;


    const commentsToShow = itemsComments.filter(c => {
      if (searchComments !== "") {
        const rgx = new RegExp(
          searchComments.replace(/[^a-zA-Z0-9]/g, ""),
          "i"
        );
        return rgx.test(c.comment) || rgx.test(c.user_creator.name);
      } else {
        return c;
      }
    });

    /**MENTIONS */
    let usersMentions = [];
    if (
      itemSelected &&
      !isFetchingUsersToComment &&
      (adminUsersToComment || operatorsUsersToComment)
    ) {
      if (itemSelected && adminUsersToComment) {
        adminUsersToComment.forEach(item => {
          usersMentions.push({
            id: item._id,
            name: item.name,
            display: `${item.name} (${item.email})`
          });
        });
      }
      if (itemSelected && operatorsUsersToComment) {
        operatorsUsersToComment.forEach(item => {
          if (!usersMentions.find(r => r.id === item.id)) {
            usersMentions.push({
              id: item._id,
              name: item.name,
              display: `${item.name} (${item.email})`
            });
          }
        });
      }

      //Añadimos los usuarios admin si aplica
      const isPartOfTheGroup =
        usersMentions.find(u => u.display === user.email) ||
        (user && user.clientRole === "admin" && user.role === "admin");

      if (isPartOfTheGroup) {
        for (let useradmin of usersAll) {
          let temp = usersMentions.find(u => u.display === useradmin.email);
          if (!temp)
            usersMentions.push({
              id: useradmin._id,
              name: useradmin.name,
              display: `${useradmin.name} (${useradmin.email})`
            });
        }
      }
      //Ordenamos
      usersMentions = [
        ...usersMentions.sort((a, b) =>
          a.display.toLowerCase() < b.display.toLowerCase()
            ? -1
            : a.display.toLowerCase() > b.display.toLowerCase()
            ? 1
            : 0
        )
      ].filter(r => r.id !== user._id);
    }
    
    return (
      <div
        ref={this.scrollDiv}
        className={
          (!itemSelectedFetching && searchComments !== "") ||
          (!itemSelectedFetching &&
            (commentsToShow.length > 1 ||
              (commentsToShow.length === 1 &&
                commentsToShow[0].position !== -1)))
            ? "bb-comments-block__items"
            : "bb-comments-block__items no-comments"
        }
        style={{ height: "calc(100vh - 340px)" }}
      >
        <div className="bb-comments-block__empty">
          <div className="center-block">
            <figure>
              <img alt="" src="/images/img_v2/icon-empty-block.svg" />
            </figure>
            <h4>
              {searchComments !== ""
                ? "No hay comentarios que coincidan con su busqueda"
                : "Aún no tenemos comentarios."}{" "}
            </h4>
          </div>
        </div>
        <div className="items-scroll">
          {!itemSelectedFetching &&
            commentsToShow.map((comment, k) => {
              const commentWhichReplied =
                comment.numberReply &&
                itemSelected.comments.find(
                  c => c._id.toString() === comment.numberReply
                );

              return (
                <div id={comment._id} key={comment._id}>
                  <CommentV2
                    comment={comment}
                    scrollToComment={this.scrollToComment}
                    scrollToReplyComment={this.scrollToReplyComment}
                    commentWhichReplied={commentWhichReplied}
                    canCreateCommentDart={canCreateCommentDart}
                    usersMentions={usersMentions}
                    downloadFileComment={this.downloadFileComment}
                    handleShowModalDeleteComment={
                      this.props.handleShowModalDeleteComment
                    }
                    clickReference={
                      comment.isHighlight ? this.commentRefToShow : null
                    }
                  />
                </div>
              );
            })}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const obj = {
    itemSelected: state.comments.itemSelected,
    itemSelectedFetching: state.comments.itemSelectedFetching,
    user: state.authUser.user,
    workclient: state.client.workclient,
    adminUsersToComment: state.comments.adminUsersToComment,
    operatorsUsersToComment: state.comments.operatorsUsersToComment,
    isFetchingUsersToComment: state.comments.isFetchingUsersToComment,
    dataDownload: state.downloads.data,
    fromKeyCollection: state.comments.fromKeyCollection,
    usersAll:
      state.users && state.users.data
        ? state.users.data.filter(
            u =>
              u.email.indexOf("@bunkey.tv") === -1 && u.clientRole === "admin"
          )
        : []
  };

  return obj;
};

const mapDispatchToProps = {
  createComment,
  startDownload,
  setkeyboardEnabled,
  updateDownload
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(MainCommentsList))
);
